export default __webpack_public_path__ + "static/media/Gloves of the Forsaken.2e78cc04.jpg";